import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';

import QrRepayment from './QrRepayment';
import ErrorBlock from './QrRepaymentError';
import QrRepaymentLoad from './QrRepaymentLoad';
import { DataWithState } from '@api/models/common';
import { MappedAccountResponse } from '@api/mappers/accountMapper';
import { QRRepayment } from '../../types/generated/pos';

interface QrRepaymentLocationState {
	qrData: QRRepayment;
	providerCode: string;
}

interface QrRepaymentPageProps {
	accountsState: DataWithState<MappedAccountResponse>;
	userName: string;
}

const QrRepaymentPage = (props: QrRepaymentPageProps) => {
	const { accountsState, userName } = props;
	const accounts = accountsState.data?.accounts;
	const location = useLocation();
	const state = location.state as QrRepaymentLocationState | null;

	if (!state?.qrData) {
		throw new Error(
			'QR data not found. Please initiate payment from account page.'
		);
	}

	const { qrData, providerCode } = state;

	if (!accounts) {
		return <QrRepaymentLoad qrData={qrData} providerCode={providerCode} />;
	}

	return (
		<QrRepayment
			qrData={qrData}
			providerCode={providerCode}
			userName={userName}
			accounts={accounts}
		/>
	);
};

const QrRepaymentPageWithError: typeof QrRepaymentPage = (props) => {
	return (
		<ErrorBoundary FallbackComponent={ErrorBlock}>
			<QrRepaymentPage {...props} />
		</ErrorBoundary>
	);
};

export default QrRepaymentPageWithError;
